<template>
  <span>
    <span
      v-if="level === null || level === -1"
      v-b-tooltip.hover
      title="Keine Informationen zur Verfügbarkeit der Leistung"
    >
      🤔
    </span>
    <span
      v-if="level === 0"
      v-b-tooltip.hover
      title="Stufe 0: Keine Informationen im Internet verfügbar"
    >
      📝
    </span>
    <span
      v-if="level === 1"
      v-b-tooltip.hover
      title="Stufe 1: Informationen zum Antrag im Internet verfügbar"
    >
      ℹ️
    </span>
    <span
      v-if="level === 2"
      v-b-tooltip.hover
      title="Stufe 2: Antragsgenerator mit Formular zum Ausdrucken im Internet verfügbar"
    >
      🖨️
    </span>
    <span
      v-if="level === 3"
      v-b-tooltip.hover
      title="Stufe 3: Antrag im Internet verfügbar"
    >
      🌏
    </span>
    <span
      v-if="level === 4"
      v-b-tooltip.hover
      title='Stufe 4: Antrag der "schnell" ausgefüllt werden kann, im Internet verfügbar'
    >
      🥳
    </span>
    <span
      v-if="partOfMvp === true"
      v-b-tooltip.hover
      title="Dieser Leistung ist Teil eines MVP"
    >
      💚
    </span>
    <span
      v-if="partOfReferenceImplementation === true"
      v-b-tooltip.hover
      title="Dieser Leistung ist Teil einer Referenzimplementierung"
    >
      💜
    </span>

    <span v-if="applicableLaws">
      <span v-for="i in applicableLaws" v-bind:key="i.id">
        <span
          v-if="i.node.name === 'Top100Bürger'"
          v-b-tooltip.hover
          title="Unter den beliebtesten 100 Leistungen bei Bürger*innenbefragung"
        >
          👍
        </span>
        <span
          v-if="i.node.name === '115-Behördenrufnummer'"
          v-b-tooltip.hover
          title="Leistungen nach denen besonders häufig bei der Behördenhotline 115 gefragt wurde"
        >
          📞
        </span>
        <span
          v-if="i.node.name === 'Top100Wirtschaft'"
          v-b-tooltip.hover
          title="Unter den beliebtesten 100 Leistung für die Wirtschaft "
        >
          📈
        </span>
      </span>
    </span>
    <span v-if="dateChangeType">
      <span
        v-if="dateChangeType === 'date_later'"
        v-b-tooltip.hover
        :title="
          'Meilenstein wurde verschoben. Vorher: ' +
            moment(previousDate).format('DD.MM.YYYY')
        "
      >
        🐢
      </span>
      <span
        v-if="dateChangeType === 'date_earlier'"
        v-b-tooltip.hover
        :title="
          'Meilenstein wurde vorgezogen. Vorher: ' +
            moment(previousDate).format('DD.MM.YYYY')
        "
      >
        🏃‍♀️
      </span>
      <span
        v-if="dateChangeType === 'date_deleted'"
        v-b-tooltip.hover
        :title="
          'Meilenstein wurde entfernt. Vorher: ' +
            moment(previousDate).format('DD.MM.YYYY')
        "
      >
        🗑️
      </span>
      <span
        v-if="dateChangeType === 'date_added'"
        v-b-tooltip.hover
        title="Meilenstein wurde neu hinzugefügt"
      >
        ➕
      </span>
    </span>
    <span v-if="costsOfRecord">
      <span
        v-if="costsOfRecord !== ''"
        v-b-tooltip.hover
        :title='"\""+costsOfRecord +"\""
        '
      >
       ⚠️
      </span>
    </span>
    <span v-if="markedAsDone !== null && markedAsStarted !== null">
      <span v-if="markedAsDone === true && markedAsStarted === true"  v-b-tooltip.hover
                  title="Meilenstein abgeschlossen">
        ✅
      </span>
      <span v-if="markedAsDone === false && markedAsStarted === true" title="Meilenstein als begonnen, aber noch nicht abgeschlossen markiert.">
        🔄
      </span>
      <span v-if="markedAsDone === false && markedAsStarted===false"  v-b-tooltip.hover
            title="Meilenstein weder als begonnen noch abgeschlossen markiert">
        ❌
      </span>
      <span v-if="markedAsDone === true && markedAsStarted===false" v-b-tooltip.hover
            title="Meilenstein als abgeschlossen aber nicht als begonnen markiert">
        ⚠️
      </span>
    </span>

  </span>
</template>

<script>
export default {
  props: [
    "level",
    "dateChangeType",
    "previousDate",
    "applicableLaws",
    "partOfMvp",
    "partOfReferenceImplementation",
    "costsOfRecord",
    "markedAsDone",
    "markedAsStarted",
  ],
  name: "OZGLevelEmoji"
};
</script>

<style scoped>
span {
  cursor: help;
  display: inline;
}
</style>
